import React from 'react'

interface RequestAnimationFrameHook {
  addBrowserAnimation: (callback: () => void) => void
}

export const useRequestAnimationFrame = (): RequestAnimationFrameHook => {
  const id = React.useRef<number | undefined>(undefined)

  const cancelBrowserAnimation = React.useCallback(() => {
    const currentId = id.current
    if (currentId !== undefined) {
      window.cancelAnimationFrame(currentId)
    }
  }, [])

  React.useEffect(() => cancelBrowserAnimation, [cancelBrowserAnimation])

  const addBrowserAnimation = React.useCallback(
    (callback: () => void) => {
      cancelBrowserAnimation()
      id.current = window.requestAnimationFrame(callback)
    },
    [cancelBrowserAnimation],
  )

  return { addBrowserAnimation }
}
